import PropTypes from 'prop-types';
import React from 'react';

export default function Info({ size = '100%', color = '#cacaca' }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 15" width={size} height={size}>
      <path
        fill={color}
        d="M7.5,0C3.4,0,0,3.4,0,7.5C0,11.6,3.4,15,7.5,15c4.1,0,7.5-3.4,7.5-7.5C15,3.4,11.6,0,7.5,0z
        M8.4,12.6H6.6v-7 h1.8V12.6z
        M7.5,4.4c-0.6,0-1-0.4-1-1c0-0.6,0.4-1,1-1c0.6,0,1,0.4,1,1C8.5,4,8.1,4.4,7.5,4.4z"
      />
    </svg>
  );
}

Info.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};
